import { map as rxjsmap } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { VehiclesCompleteChecklist } from '../../shared/models/complete-checklist';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VehicleControlService {
  constructor(private http: HttpClient) {}

  getVehicleControlById(Id: number) {
    return this.http
      .get(`${environment.BASE_URL}/vehicle/vehiclecontrol/${Id}`).pipe(rxjsmap((result: any) => result));
  }

  addVehicleControl(vehicleCtrl) {
    return this.http
      .post(`${environment.BASE_URL}/vehicle/vehiclecontrol`, vehicleCtrl).pipe(rxjsmap(result => result));
  }

  updateVehicleControl(vehicleCtrl, Id) {
    return this.http
      .put(`${environment.BASE_URL}/vehicle/vehiclecontrol/${Id}`, vehicleCtrl).pipe(rxjsmap(result => result));
  }

  deleteVehicleControl(Id: number) {
    return this.http
      .delete(`${environment.BASE_URL}/vehicle/controldelete/${Id}`).pipe(rxjsmap(result => result));
  }

  getVehicleControlByVehicleId(Id: number) {
    return this.http
      .get(`${environment.BASE_URL}/vehicle/vehiclecontrols/${Id}`).pipe(rxjsmap((result: any) => result));
  }

  createCompleteChecklist(
    VehiclesCompleteChecklist: VehiclesCompleteChecklist
  ) {
    return this.http
      .post(
        `${environment.BASE_URL}/vehicle/CompleteChecklistByVehicleId`,
        VehiclesCompleteChecklist
      ).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
}
